<template>
    <div>
    <ValidationProvider tag="div"
                        :rules="combinedRules"
                        :name="vid"
                        :label="label || name"
                        :mode="mode"
                        :model-value="modelValue"
                        :validate-on-mount="false"
                        v-slot="{ errors }">
        <b-form-group :label-for="name || labelText"
                      :label="labelText">
            <template v-for="(_, name) in $slots" :key="name"
                      v-slot:[name]="slotData">
                <slot :name="name" v-bind="slotData" />
            </template>
            <b-input-group>
                <b-form-input
                    ref="input"
                    type="tel"
                    :model-value="displayValue"
                    @update:model-value="onInput($event)"
                    :disabled="$attrs.disabled"
                    :name="name"
                    :class="{
                        'is-invalid': errors.length > 0,
                    }"
                    @focus="$event.target.select()"
                ></b-form-input>
                <b-button v-if="value && !$attrs.disabled"
                    class="px-0"
                    size="md"
                    @click="handleInput(null)"
                    tabindex="-1">
                    <b-icon-x style="font-size: 1.15rem;"></b-icon-x>
                </b-button>
            </b-input-group>

            <span class="text-danger">{{ errors[0] }}</span>
        </b-form-group>
    </ValidationProvider>
    </div>
</template>
<script>
    import debounce from 'lodash/debounce';
    import baseInputs from '@/components/mixins/BaseInputs';
    import validatedInput from '@/components/mixins/ValidatedInput';
    // TODO: Replace with vue-tel-input for Vue 3
    export default {
        name: 'p-phonenumber',
        mixins: [baseInputs, validatedInput],
        components: {},
        data: function () {
            return {
                isInputActive: false,
            };
        },
        props: {
            // value prop now comes from modelValue via BaseInputs mixin
            debounceWait: {
                type: Number,
                default: 0
            },

        },
        computed: {
            value() { return this.modelValue; },
            displayValue() {
                return this.formatPhone(this.modelValue);
            },
            combinedRules() {
                if (this.rules.length) {
                    return this.rules + '|max:50';
                }
                return 'max:50';
            }
        },
        created() {
            if (this.debounceWait > 0) {
                this.handleInput = debounce(this.handleInput, this.debounceWait);
            }
        },
        methods: {
            focus: function () {
                this.$refs.input?.$el?.focus?.() || this.$refs.input?.focus?.();
            },
            formatPhone(val) {
                if (!val) return '';
                const digits = val.replace(/\D/g, '');
                if (digits.length <= 3) return digits;
                if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
                return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
            },
            onInput(val) {
                // Store raw digits only
                const digits = val ? val.replace(/\D/g, '') : null;
                this.handleInput(digits || null);
            }
        }
    };
</script>

<style scoped lang="scss">
@import '@/styles/app/common/variables.scss';

:deep(.form-control) {
    background-color: white !important;
}
:deep(.form-control:-webkit-autofill),
:deep(.form-control:-webkit-autofill:hover),
:deep(.form-control:-webkit-autofill:focus) {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: #515a61 !important;
    font-weight: 400 !important;
    transition: background-color 5000s ease-in-out 0s;
}
:deep(.btn) {
    background-color: white !important;
    border: 1px solid #7D93A7 !important;
    border-left: 1px solid #7D93A7 !important;
    border-radius: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    color: #333 !important;
}
</style>
